import { LogOut, Settings } from "lucide-react";
import { LOGO_URL } from "@/lib/assets";
import { useAuth } from "@/context/AuthContext";

export const AppHeader = ({ subtitle, onSettings }) => {
  const { user, logout } = useAuth();
  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-30 bg-white/90 backdrop-blur border-b border-slate-200"
    >
      <div className="max-w-md mx-auto px-4 h-16 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img src={LOGO_URL} alt="SPLENDI" className="h-9 w-auto object-contain" />
          {subtitle && (
            <span className="text-sm font-semibold text-slate-500 uppercase tracking-wide">
              {subtitle}
            </span>
          )}
        </div>
        <div className="flex items-center gap-1">
          {onSettings && (
            <button
              data-testid="open-settings-button"
              onClick={onSettings}
              className="h-10 w-10 rounded-lg flex items-center justify-center text-slate-500 hover:text-primary transition-colors active:scale-95"
              aria-label="Impostazioni"
            >
              <Settings className="h-5 w-5" />
            </button>
          )}
          <button
            data-testid="logout-button"
            onClick={logout}
            className="h-10 w-10 rounded-lg flex items-center justify-center text-slate-500 hover:text-destructive transition-colors active:scale-95"
            aria-label="Esci"
          >
            <LogOut className="h-5 w-5" />
          </button>
        </div>
      </div>
      {user?.name && (
        <div className="max-w-md mx-auto px-4 pb-2 -mt-1">
          <span className="text-xs text-slate-400">Ciao, {user.name}</span>
        </div>
      )}
    </header>
  );
};
